<template>
    <sms-row
        :sender="sender"
        :is-global-admin="isGlobalAdmin"
        :saving-price="savingPrice"
        :saving-credits-cost="savingCreditsCost"
        :channel-label="t('settings-connections-channels-rcs')"
        @click="$emit('click', $event)"
        @execute-command="$emit('execute-command', $event)"
        @set-as-default="$emit('set-as-default')"
        @open-webhooks="$emit('open-webhooks')"
        @update-price="(row, value) => $emit('update-price', row, value)"
        @update-credits-cost="(row, value) => $emit('update-credits-cost', row, value)"
    />
</template>

<script>
import SmsRow from './sms.vue';

export default {
    name: 'rcs-row',
    components: { SmsRow },
    props: {
        sender: { type: Object, required: true },
        isGlobalAdmin: { type: Boolean, default: false },
        savingPrice: { default: null },
        savingCreditsCost: { default: null },
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
    },
};
</script>
